import { useBotInfo } from "../contexts/BotContext";
import "./LoadingScreen.css";

function LoadingScreen() {
  const { botInfo } = useBotInfo();

  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-logo">
          <div className="loading-circle">
            <div className="loading-circle-inner"></div>
          </div>
          {botInfo?.avatarURL ? (
            <img
              src={botInfo.avatarURL}
              alt="Bot Avatar"
              className="loading-avatar"
            />
          ) : (
            <div className="loading-icon">🤖</div>
          )}
        </div>
        <div className="loading-text">
          <h2>Loading Dashboard</h2>
          <div className="loading-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;
